import script from "./selectBox.vue?vue&type=script&setup=true&lang=js"
export * from "./selectBox.vue?vue&type=script&setup=true&lang=js"

import "./selectBox.vue?vue&type=style&index=0&id=1427811a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1427811a"]])

export default __exports__